module.exports = __webpack_public_path__ + "static/media/034.db59ba81.jpg";